{
  "auth.email_signup.email.label": "Courriel",
  "auth.email_signup.first_name_caption": "Vous pourrez ajouter un nom de votre choix dans votre compte plus tard.",
  "auth.email_signup.first_name_on_driver_license.label": "Prénom sur le permis de conduire",
  "auth.email_signup.firstname.required": "Prénom requis",
  "auth.email_signup.last_name_on_driver_license.label": "Nom sur le permis de conduire",
  "auth.email_signup.lastname.required": "Nom requis",
  "auth.email_signup.marketing.label": "M’envoyer des promotions et des mises à jour par courriel",
  "auth.email_signup.marketing.optin_matrix_label": "M’envoyer des mises à jour, des recommandations et des offres par courriel",
  "auth.email_signup.sms_marketing.label": "M’envoyer des promotions et des mises à jour par message texte",
  "auth.email_signup.or_sign_up_with_others": "Inscription avec {#facebookLink}Facebook{/facebookLink} ou {#googleLink}Google{/googleLink}",
  "auth.email_signup.password.error_min_length": "Le mot de passe doit contenir au moins 8 caractères",
  "auth.email_signup.email.error_format": "Veuillez saisir une adresse courriel valide",
  "auth.email_signup.password.label": "Mot de passe",
  "auth.email_signup.sign_up": "Inscription",
  "auth.email_signup.terms_of_service.label": "J’accepte les {#termsOfServiceLink}Conditions d’utilisation{/termsOfServiceLink} et l’{#privacyPolicyLink}Avis de confidentialité{/privacyPolicyLink}.",
  "auth.email_signup.title": "Démarrer"
}
